
import { useLocation } from 'react-router-dom';
import { useCanonicalUrl } from '@/hooks/useCanonicalUrl';

const BASE_URL = 'https://laschispas.com';

export const CanonicalManager = () => {
  const location = useLocation();
  const canonicalUrl = `${BASE_URL}${location.pathname}`;

  useCanonicalUrl(canonicalUrl);

  return null;
};
